import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractService } from './abstract-service.service';
import { AdminTimesheet } from '../models/admin-timesheet.model';

interface ExportjsonBody {
    UserProfileIds: string[];
    Type: string;
}

AdminTimesheet;
@Injectable({
    providedIn: 'root',
})
export class ReportsService extends AbstractService {
    path = '/report';

    exportReport(
        route: string[],
        queryParameters?: Map<string, unknown>,
    ): Observable<Blob> {
        let url = this.baseUrl + this.path;

        url +=
            this._buildRouteFromStringArray(route) +
            this._buildQueryParameters(queryParameters);

        return this.httpClient.get(url, {
            headers: {
                accept: 'application/octet-stream',
                'content-type': 'application/octet-stream',
            },
            responseType: 'blob',
        });
    }

    exportAdminReport(
        route: string[],
        payload: ExportjsonBody,
        queryParameters: Map<string, unknown>,
    ): Observable<Blob> {
        let url = this.baseUrl + this.path;

        url +=
            this._buildRouteFromStringArray(route) +
            this._buildQueryParameters(queryParameters);

        return this.httpClient.post(url, payload, {
            headers: {
                accept: 'application/octet-stream',
                'content-type': 'application/json',
            },
            responseType: 'blob',
        });
    }
}
